import React from 'react';
import { Map, Marker, Popup, TileLayer, Polyline, LayersControl } from 'react-leaflet';
import styled from 'styled-components';
import hereMapKey from 'config/hereMapKey';
import 'react-leaflet-fullscreen-control';
import MarkerCustom from './components/MarkerCustom';
import MarkerPopup from './components/MarkerPopup';
import Leaflet from 'leaflet';
import color from 'config/color';

const { BaseLayer } = LayersControl;
const defaultPosition = [13.664273, 100.653512];
const hereStyle = 'normal.day';
const hereTileUrl = `https://2.base.maps.ls.hereapi.com/maptile/2.1/maptile/newest/${hereStyle}/{z}/{x}/{y}/256/png8?apiKey=${hereMapKey}&lg=tha&ppi=72&pview=DEF`;
const Container = styled.div`
  .leaflet-container {
    height: 100%;
    width: 100%;
    z-index: 0;
  }
`;

class LeafletMap extends React.Component {
  renderMarkerShipment = markerShipment => {
    if (markerShipment && markerShipment.length > 0) {
      return markerShipment.map(item => {
        console.log(item)
        const res = item.location.split(",");
        console.log(item ,res)
        return <MarkerCustom position={[res[0],res[1]]} text={item.text} />;
      });
    }

    return null;
  };

  renderLayers = () => {
    const assignLayers = [
      {
        name: 'Here Map',
        url: hereTileUrl,
        attribution: '&copy; HERE MAP',
        checked: true,
      },
      {
        name: 'OpenStreet Map',
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        checked: false,
      },
    ];

    return (
      <LayersControl position="topright">
        {assignLayers.map((item, index) => (
          <BaseLayer key={index} checked={item.checked} name={item.name}>
            <TileLayer url={item.url} attribution={item.attribution} />
          </BaseLayer>
        ))}
      </LayersControl>
    );
  };

  setBound = boundsLatLng => {
    if (boundsLatLng && boundsLatLng.length > 0) {
      return Leaflet.latLngBounds(boundsLatLng);
    }

    return null;
  };

  render() {
    return (
      <Container>
        <Map
          center={defaultPosition}
          zoom={15}
          maxZoom={20}
          fullscreenControl
          bounds={this.setBound(this.props.boundsLatLng)}
          closePopupOnClick={false}
        >
          {this.renderLayers()}
          {this.renderMarkerShipment(this.props.markerShipment)}
        </Map>
      </Container>
    );
  }
}

export default LeafletMap;
